import { PropsWithChildren } from 'react'

import { useAuthOwnershipWallet } from '../hooks/useAuthOwnershipWalletGate'
import { useLogout } from '@privy-io/react-auth'
import { useAuthWallets } from 'hooks/auth/useAuthWallets'

const AuthOwnershipWalletGate = ({ children }: PropsWithChildren<{}>) => {
  const { isLoading } = useAuthOwnershipWallet()
  const { isOwnershipWalletDisconnected } = useAuthWallets()
  const { logout } = useLogout()

  if (isLoading) {
    return null
  }

  if (isOwnershipWalletDisconnected) {
    logout()
  }

  return <>{children}</>
}

export default AuthOwnershipWalletGate
